import VexaBox from '@/components/web3/VexaBox';

const WalletPanel = () => <VexaBox />;

export default WalletPanel;

